import { HubEvents } from "../common/HubEventsEnum";
import { GridBaseModel, IGridBaseModel } from "../common/GridBaseModel";

export class ImpactGroupsHub extends GridBaseModel implements IGridBaseModel {
  hubName: string = "impact-groups";

  constructor() {
    super("impact-groups");
  }

  onLoadData = callback => this.registerIncomingEvent(HubEvents.ON_LOAD_IMPACT_GROUP_DATA, callback);

  invokeLoadData = async (organisationId: number, projectId: number) => {
    if (!this.isConnectionStarted) return;
    await this.connection.invoke(HubEvents.INVOKE_LOAD_IMPACT_GROUP_DATA, {
      organisationId: organisationId,
      projectId: projectId
    });
  };
}
const instance = new ImpactGroupsHub();
export default instance;
